import React from 'react';
import wordmarkSrc from '../assets/acuwize-wordmark.png';
import './header.scss';

// Top-of-page chrome shared between portal and editor.
// Slots: workgroup switcher (children) + user menu (right).
// Why a slot pattern: portal owns workgroup switcher; editor owns its own
// inline workspace switcher; we don't want either to leak into shared.

function Header({productName, workgroupSlot, userMenuSlot}) {
    return (
        <header className="acuwize-header">
            <div className="acuwize-header__brand">
                <img className="acuwize-header__wordmark" src={wordmarkSrc} alt="Acuwize" />
                <span className="acuwize-header__sep" aria-hidden="true">/</span>
                <span className="acuwize-header__product">{productName}</span>
            </div>
            <div className="acuwize-header__center">{workgroupSlot}</div>
            <div className="acuwize-header__right">{userMenuSlot}</div>
        </header>
    );
}

export default Header;
